import { message } from "antd";
import React, { createContext, useState, useContext, ReactNode } from "react";


const AuthContext = createContext();


export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuth must be used within an AuthProvider");
    }
    return context;
};


export const AuthProvider = ({ children }) => {
    const [token, setToken] = useState(
        localStorage.getItem("token")
    );
    const [user, setUser] = useState(
        JSON.parse(localStorage.getItem("user")) || null
    );
    const [fcmToken, setFcmToken] = useState(
        JSON.parse(localStorage.getItem("fcmToken")) || ""
    );

    const getFcmToken = (newToken) => {
        setFcmToken(newToken)
        localStorage.setItem("fcmToken", JSON.stringify(newToken));
    }
    
    const getCurrentUser = (newUser) => {
        setUser(newUser);
        localStorage.setItem("user", JSON.stringify(newUser));
    };

    const login = (newToken) => {
        setToken(newToken);

    };

    const logout = () => {
        setToken(null);
        localStorage.removeItem("token");
        message.error("You are logout !")
    };

    return (
        <AuthContext.Provider value={{ token, login, logout, getCurrentUser, user, getFcmToken, fcmToken }}>
            {children}
        </AuthContext.Provider>
    );
};
